module.exports = __webpack_public_path__ + "static/media/logo-social-security-fund.fed1b286.png";